/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FieldChange { 
    field_name?: string;
    field_kind?: FieldChangeFieldKindEnum;
    binding_target?: string;
    old_value?: string;
    new_value?: string;
}
export enum FieldChangeFieldKindEnum {
    NATIVE = 'NATIVE',
    EAV = 'EAV'
};



